import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CompanyGroup, CompanyGroupType } from "./gorup.model";

const url = environment.api;

@Injectable({
    providedIn: "root",
})
export class CompanyGroupService {
    constructor(private http: HttpClient) {
    }

    //companyGroups: CompanyGroup[] = [];
    companyGroup: CompanyGroup = new CompanyGroup();

    getCompanyGroups(idCompany: number, type: CompanyGroupType, idUser?: number) {

        let httpParams = new HttpParams();
        httpParams = httpParams.set("type", type);

        if (idUser) {
            httpParams = httpParams.set("idUser", idUser);
        }

        return this.http.get<CompanyGroup[]>(url + "company/" + idCompany + "/group", { params: httpParams });
    }

    getCompanyGroup(companyGroup: CompanyGroup, idCompanyGroup: number) {
        return this.http.get<CompanyGroup>(url + "company/" + companyGroup.idCompany + "/group/" + idCompanyGroup);
    }

    postCompanyGroups(companyGroup: CompanyGroup) {
        return this.http.post(url + "company/" + companyGroup.idCompany + "/group/", companyGroup);
    }

    putCompanyGroup(companyGroup: CompanyGroup) {
        return this.http.put(url + "company/" + companyGroup.idCompany + "/group/" + companyGroup.id, companyGroup);
    }

    deleteCompanyGroup(idCompanyGroup: number, idCompany: number) {
        return this.http.delete(url + "company/" + idCompany + "/group/" + idCompanyGroup);
    }

    postCompanyGroupUser(idCompanyGroup: number, idCompany: number, idUsers: number) {
        return this.http.post(url + "company/" + idCompany + "/group/" + idCompanyGroup + '/user/' + String(idUsers), undefined);
    }

    deleteCompanyGroupUser(idCompanyGroup: number, idCompany: number, idUser: number) {
        return this.http.delete(url + "company/" + idCompany + "/group/" + idCompanyGroup + '/user/' + idUser);
    }




}
